export default __webpack_public_path__ + "assets/e891f340b9c8da015f8f146d8dac0358.svg";